import type { SVGProps } from 'react';
const SvgReceiptCrossStreamlineCore = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} fill="none" viewBox="0 0 14 14" {...props}>
    <desc>{'Receipt Cross Streamline Icon: https://streamlinehq.com'}</desc>
    <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
      <path d="m7.5 8.5-4-4M7.5 4.5l-4 4M11.5 1H3a2 2 0 0 0-2 2v10l2.25-1.5L5.5 13l2.25-1.5L10 13V2.5A1.5 1.5 0 0 1 11.5 1m0 0A1.5 1.5 0 0 1 13 2.5V5h-3" />
    </g>
  </svg>
);
export default SvgReceiptCrossStreamlineCore;
